import { GetPosParams } from "@bvhi/backend-api/apis";
import { Card, CardContent, GridPaginationModel, GridSortModel } from "@bvhi/ui-base";
import { PosDataGrid } from "./pos-datagrid";

interface Props {
  requestParams: GetPosParams;
  updateCallback: (paginationModel: GridPaginationModel, sortModel: GridSortModel) => void;
}

export const PosDataGridCard = ({ requestParams, updateCallback }: Props) => {
  return (
    <>
      <Card>
        <CardContent restrictContentWidth={false}>
          <PosDataGrid requestParams={requestParams} updateCallback={updateCallback} />
        </CardContent>
      </Card>
    </>
  );
};
